import actions from '@/store/products/actions';
import filterProductForPromoCodes from '@/utils/filterProductForPromoCodes';

const productsModule = {
  state: () => ({
    productList: [],
    cardImages: [],
    productCollections: [],
    currentProductCollection: {},
    isCurrentProductCollectionLoaded: false,
    isLoading: false,
    isProductsLoaded: false,
    error: null,
    allInfoProductCollection: [],
    allProductsList: {},
  }),
  getters: {
    filteredProduct: (state) => (type) => (
      state.productList ? state.productList
        .find(({ name }) => name === type) : {}
    ),
    sortedProductsByPrice(state) {
      return state.productList ? state.productList.sort((a, b) => a.price - b.price) : [];
    },
    sortedProductsByIndex(state) {
      return state.productList ? state.productList.sort((a, b) => a.index - b.index) : [];
    },
    allProducts(state, getters, rootState) {
      const companies = rootState.companies?.companies || [];
      return filterProductForPromoCodes(state.allProductsList, false, companies);
    },
  },
  mutations: {
    GET_PRODUCT_START(state) {
      state.isLoading = true;
      state.error = null;
      state.isProductsLoaded = false;
    },
    GET_PRODUCTS_SUCCESS(state, payload) {
      state.productList = payload;
      state.isLoading = false;
      state.isProductsLoaded = true;
      state.error = null;
    },
    GET_PRODUCTS_FAILURE(state, data) {
      state.isLoading = false;
      state.isProductsLoaded = false;
      state.error = data;
    },
    GET_CARD_IMAGES_SUCCESS(state, data) {
      state.cardImages = data;
    },
    GET_PRODUCT_COLLECTIONS_START(state) {
      state.isLoading = true;
    },
    GET_PRODUCT_COLLECTIONS_SUCCESS(state, payload) {
      state.isLoading = false;
      state.productCollections = payload;
    },
    GET_PRODUCT_COLLECTIONS_FAIL(state, data) {
      state.isLoading = false;
      state.error = data;
    },
    GET_ONE_PRODUCT_COLLECTIONS_START(state) {
      state.isLoading = true;
      state.isCurrentProductCollectionLoaded = false;
    },
    GET_ONE_PRODUCT_COLLECTIONS_SUCCESS(state, payload) {
      state.isLoading = false;
      state.isCurrentProductCollectionLoaded = true;
      state.currentProductCollection = payload;
    },
    GET_ONE_PRODUCT_COLLECTIONS_FAIL(state, data) {
      state.isLoading = false;
      state.error = data;
      state.isCurrentProductCollectionLoaded = false;
    },
    GET_ALL_PRODUCT_COLLECTIONS_START(state) {
      state.isLoading = true;
    },
    GET_ALL_PRODUCT_COLLECTIONS_SUCCESS(state, payload) {
      state.isLoading = false;
      state.allInfoProductCollection = payload;
      state.currentProductCollection = payload;
    },
    GET_ALL_PRODUCT_COLLECTIONS_FAIL(state, data) {
      state.isLoading = false;
      state.error = data;
    },
    CLEAR_CURRENT_PRODUCT_COLLECTIONS(state) {
      state.currentProductCollection = [];
    },
    GET_ALL_PRODUCTS_SUCCESS(state, payload) {
      state.allProductsList = payload;
    },
  },
  actions,
  namespaced: true,
};

export default productsModule;
